/**
 * Application router configuration.
 * 
 * Includes:
 * - All application routes and associated menu entries
 * - Route guards to check if the current user has permission to access a route
 * - A catch-all `NotFound` component for unknown routes
 */

import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import NotFoundComponent from './components/notFound.vue'

/**
 * Route guard to check if the current user has permission to access a route.
 * 
 * Redirects the user if they lack the required permission or are not authenticated.
 * 
 * @param {RouteLocationNormalized} to - The target route being navigated to.
 * @param {RouteLocationNormalized} from - The current route being navigated away from.
 * @param {Function} next - The function to resolve the navigation.
 * @param {string} permission - The required permission or role to access the route.
 */
function checkPermissionsAndNavigate(to, from, next, permission) {
    console.log('checking permissions:', permission, store.state.user.permissions[permission].viewPage,"login:",store.state.user.loggedIn );
    if (store.state.user.loggedIn && store.state.user.permissions[permission].viewPage) {
      next();
    } else {
      store.dispatch('showMessage', { type: 'error', text: 'You do not have permission to view this page.' });
      next({ name: 'home', params: { unauthorized: true } });
    }
  }

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '*', component: NotFoundComponent },
        {
            path: '/',
            name: 'home',
            icon: 'mdi-home',
            label: 'STR_HOME',
           
           
            component: () => import('./views/Home.vue')
        }
        ,
        {
            path: '/dashboard',
            name: 'dashboard',
            icon: 'mdi-view-dashboard',
            label: 'STR_DASHBOARD',
            props: true,
           
            
                
            component: () => import('./views/Dashboard.vue'),
            beforeEnter:(to, from, next) => {
                if (!store.state.user.loggedIn) next({ name: 'home' })
                else next()
            }

        },
        {
            path: '/newShipment',
            name: 'newShipment',
            icon: 'mdi-package-variant',
            label: 'STR_ERF',   
            
           
            component: () => import('./views/newShipment.vue'),
            beforeEnter: (to, from, next) => checkPermissionsAndNavigate(to, from, next, 'newShipment')

        }, {
            path: '/loadingList',
            name: 'loadingList',
            icon: 'mdi-package-variant',
            label: 'STR_ERF',   
            
           
            component: () => import('./views/loadingList.vue'),
            beforeEnter: (to, from, next) => checkPermissionsAndNavigate(to, from, next, 'loadingList')

        },
         /*{
            name: 'loadingList',
            path: "/t_n_t/zl2.php",
            icon: 'mdi-clipboard-list',
            label: 'STR_ZL2',
           
            beforeEnter: (to, from, next) => checkPermissionsAndNavigate(to, from, next,  "/t_n_t/zl2.php")

        },*/
        {
            path: '/damageReport',
            name: 'damageReport',
            icon: 'mdi-glass-fragile',
            label: 'STR_NEWDAMAGE',
           
            
        
            component: () => import('./views/damageReport.vue'),
            beforeEnter: (to, from, next) => checkPermissionsAndNavigate(to, from, next, 'damageReport')

        },
        {
            path: '/damages',
            name: 'damages',
            icon: 'mdi-truck-alert',
            label: 'STR_PSDQ',
            props: true,
            

            component: () => import('./views/Damages.vue'),
            beforeEnter: (to, from, next) => checkPermissionsAndNavigate(to, from, next, 'damages')
        },
        {
            path: '/returnableContainer',
            name: 'returnableContainer',
            icon: 'mdi-recycle',
            label: 'STR_MWBSTAT',
            
           

            component: () => import('./views/returnableContainer.vue'),
            beforeEnter: (to, from, next) => checkPermissionsAndNavigate(to, from, next, 'returnableContainer')
        },
        {
            path: '/contacts',
            name: 'contacts',
            icon: 'mdi-clipboard-account',
            label: 'STR_CONTACTS',
            
          
            component: () => import('./views/Contacts.vue'),
            beforeEnter: (to, from, next) => checkPermissionsAndNavigate(to, from, next, 'contacts')


        },
       {
            path: '/newPassword',
            name: 'newPassword',
            active: true,
            component: () => import('./views/newPassword.vue')
        }
        ,
        {
            path: '/ticket',
            name: 'ticket',
            icon: 'mdi-sticker-text',
            label: 'STR_TICKET',
            
          
            component: () => import('./views/Tickets.vue')
            ,
            beforeEnter: (to, from, next) => checkPermissionsAndNavigate(to, from, next, 'ticket')

        }
        ,
        {
            path: '/track',
            name: 'track',
            icon: 'mdi-crosshairs-gps',
            label: 'STR_RESEARCH', 
            props: true,   
            component: () => import('./views/Track.vue')
        },
        {
            path: '/package',
            name: 'package',        
            component: () => import('./views/Package.vue')
        }
    ]
})
